import { post } from './ajax';
import { env } from './env';
import { encrypt } from '@/common';
import nodeForgeEncrypt from 'node-forge';

class Api {
  post(
    url: string,
    originParams: any = {},
    settings = { showToast: true, needCommonErrorHandler: true }
  ) {
    const params = { ...env.commonParams, ...originParams };

    if (url !== '/qdbsign/sign') {
      encrypt.normalEncrypt(params, nodeForgeEncrypt);
    }
    return post(url, params, settings);
  }

  // 查询支付设置列表
  paypass(data: any = {}): Promise<any> {
    return this.post('/api/wallet/paypass', data);
  }

  // 是否允许开启开启指纹
  touchPayAllowed(data: any = {}): Promise<ITouchPayAllowed> {
    return this.post('/api/wallet/touch-pay-allowed', data);
  }

  // 开启指纹支付/面容ID支付
  enableTouchPay(data: any = {}): Promise<ISuccess> {
    return this.post('/api/wallet/enable-touch-pay', data);
  }

  // 关闭指纹支付/面容ID支付
  disableTouchPay(data: any = {}): Promise<any> {
    return this.post('/api/wallet/disable-touch-pay', data);
  }

  // 密码验证页面
  preModifyPayhash(data: any = {}): Promise<any> {
    return this.post('/api/mpm/premodifypayhash', data);
  }

  // 修改密码
  modifyPayhash(data: any = {}): Promise<any> {
    return this.post('/api/mpm/modifypayhash', data);
  }

  enterNoPassPayVerify(data: any = {}): Promise<INoPassPayVerifyConfig> {
    return this.post('/api/wallet/enter-nopasspay-verify', data);
  }

  judgeVerify(data: any = {}): Promise<INoPassPayConfig> {
    return this.post('/api/wallet/set-nopass-verify', data);
  }

  setNoPassPay(data: any = {}): Promise<ISetNoPassPayConfig> {
    return this.post('/api/wallet/setnopasspay', data);
  }

  // 同意协议
  signAgreement(url: string): Promise<ApiSuccess> {
    return this.post(url);
  }

  // 小额免密协议升级
  noPassPaySignAgreement(data: any = {}): Promise<any> {
    return this.post('/api/wallet/setnopasspay-agrt-upgrade', data);
  }

  // https://km.sankuai.com/page/1339163859
  // 吊销CFCA数字证书
  revokeUserDigiCert(data: any = {}): Promise<any> {
    return this.post('/qdbverify/revokeuserdigicert', data, {
      showToast: true,
      needCommonErrorHandler: false
    });
  }
}

export const api = new Api();
